import { createFileRoute } from '@tanstack/react-router';

import { ShopHome } from '@/features/shop/ShopHome';

export const Route = createFileRoute('/_authenticated/shop/')({
  component: ShopHome,
});
